var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25H16C18.0711 1.25 19.75 2.92893 19.75 5V7C19.75 8.2267 19.161 9.31583 18.2504 10C19.161 10.6842 19.75 11.7733 19.75 13V15C19.75 17.0711 18.0711 18.75 16 18.75H10.75V19.5C10.75 21.2949 9.29493 22.75 7.5 22.75C5.70507 22.75 4.25 21.2949 4.25 19.5V18C4.25 17.5858 4.58579 17.25 5 17.25C5.41421 17.25 5.75 17.5858 5.75 18V19.5C5.75 20.4665 6.5335 21.25 7.5 21.25C8.4665 21.25 9.25 20.4665 9.25 19.5V2C9.25 1.58579 9.58579 1.25 10 1.25ZM18.25 7V5C18.25 3.75736 17.2426 2.75 16 2.75H10.75V9.25H16C17.2426 9.25 18.25 8.24264 18.25 7ZM16 10.75H10.75V17.25H16C17.2426 17.25 18.25 16.2426 18.25 15V13C18.25 11.7574 17.2426 10.75 16 10.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.7ad082108b63cb97f96e00e11559cdda.svg";
export { ForwardRef as ReactComponent };